import { APIClient } from 'cx-api-client-lite';

const Auth = new APIClient({
  createToken: {
    path: '/auth/v1/token',
    method: 'POST',
    options: {
      withCredentials: true,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    },
  },
});

export default Auth;
